<template>
  <div>
    <div class="table-wrapper">
      <div class="table-responsive">
        <b-table
          :items="courier_offers"
          :fields="courier_offers_fields()"
          :tbody-tr-class="rowClass"
        >
          <template #cell(delievery_price)="data">
            {{ data.item.delivery_price }}
            {{ showCurrency(data.item.delivery_price_currency) }}
          </template>
          <template #cell(view)="data">
            <button class="btn btn-link" @click="openOffer(data.item)">
              <i class="fa fa-search"></i>
            </button>
          </template>
          <template #cell(choose)="data">
            <label>
              <button
                class="btn btn-sm btn-success"
                :disabled="
                  !data.item.is_accepted || is_selected /* || !is_owner*/
                "
                @click="selectCourier(data.item.ID)"
              >
                {{ $t("message.contracts.select_courier") }}
              </button>
              <!-- <input type="radio" :id="'select'+data.item.id" name="courier" :disabled="!data.item.is_accepted/* || !is_owner*/" :value="data.item.ID" v-model="current_courier_offer_id">
                          Выбрать -->
            </label>
          </template>
          <template #cell(offer_date)="data">
            {{ data.value.split(" ")[0] }}
          </template>
          <template #cell(date_of_delivery)="data">
            <span v-if="data.value !== ''">{{ momentum(data.value) }}</span>
          </template>
        </b-table>
      </div>
  </div>
    <div v-if="!is_selected">
      <button
        class="btn btn-outline-success btn-sm"
        v-if="can_request"
        @click="createRequest"
        v-b-modal.modal-offer
      >
        {{ $t("message.contracts.delivery_request") }}
      </button>
    </div>
    <!-- <button class="btn btn-info float-right" v-if="is_owner && current_courier_offer_id!=''" @click="selectCourier">{{$t('message.contracts.select_courier')}}</button> -->
    <b-modal
      id="modal-offer"
      hide-footer
      :title="
        $t('message.contracts.delivery_request_modal_title') + ' ' + contract_id
      "
      size="lg"
    >
      <div class="row">
        <div class="col-6">
          <strong>
            {{ $t("message.contracts.delivery_request_from") }}:
            <span v-if="is_view == true">{{
              offer.countragent_1.org_name
            }}</span>
            <span v-else>{{ current_company.org_name }}</span>
          </strong>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required',
              delivery_type_focused
                ? 'focused'
                : '' /*, $v.offer.type_of_movement.$error?'has-danger label-floating':''*/,
            ]"
          >
            <v-select-popup
              :indata="delivery_types"
              :placeholder="$t('message.contracts.delivery_type')"
              v-model="offer.type_of_movement"
              :disabled="is_view"
            />

            <!-- <v-select id="delivery_type" :options="delivery_types" label="display_text" :class="['form-control', typeof offer.type_of_movement !== 'undefined' && offer.type_of_movement.value!==''?'vs--selected':'']" v-model="offer.type_of_movement" :placeholder="$t('message.contracts.delivery_type')" @focus="delivery_type_focused=true" @blur="delivery_type_focused=false"></v-select> -->
            <!-- <label for="delivery_type" class="form-label-group-label shorter">{{$t('message.contracts.delivery_type')}}</label> -->
            <!-- <label v-if="form_error && !$v.offer.type_of_movement.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.from_address.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              :disabled="is_view"
              type="text"
              class="form-control"
              v-model="offer.from_address"
              :placeholder="$t('message.contracts.from_address')"
              autocomplete="off"
              style="cursor: auto"
              id="from_address"
            />
            <label for="from_address" class="form-label-group-label shorter">{{
              $t("message.contracts.from_address")
            }}</label>
            <!-- <label v-if="form_error && !$v.offer.from_address.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.to_address.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              :disabled="is_view"
              type="text"
              class="form-control"
              v-model="offer.to_address"
              :placeholder="$t('message.contracts.to_address')"
              autocomplete="off"
              style="cursor: auto"
              id="to_address"
            />
            <label for="to_address" class="form-label-group-label shorter">{{
              $t("message.contracts.to_address")
            }}</label>
            <!-- <label v-if="form_error && !$v.offer.to_address.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.weight.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              :disabled="is_view"
              type="number"
              class="form-control"
              v-model="offer.weight"
              :placeholder="$t('message.contracts.weight')"
              autocomplete="off"
              style="cursor: auto"
              id="weight"
            />
            <label for="weight" class="form-label-group-label shorter">{{
              $t("message.contracts.weight")
            }}</label>
            <!-- <label v-if="form_error && !$v.offer.weight.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.volume.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              :disabled="is_view"
              type="number"
              class="form-control"
              v-model="offer.volume"
              :placeholder="$t('message.contracts.volume')"
              autocomplete="off"
              style="cursor: auto"
              id="volume"
            />
            <label for="volume" class="form-label-group-label shorter">{{
              $t("message.contracts.volume")
            }}</label>
            <!-- <label v-if="form_error && !$v.offer.volume.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required' /*, $v.offer.delivery_price.$error?'has-danger label-floating':''*/,
            ]"
          >
            <input
              :disabled="is_view && is_offer_mine(offer)"
              type="number"
              class="form-control"
              v-model="offer.delivery_price"
              :placeholder="$t('message.contracts.delivery_price')"
              autocomplete="off"
              style="cursor: auto"
              id="delivery_price"
            />
            <label
              for="delivery_price"
              class="form-label-group-label shorter"
              >{{ $t("message.contracts.delivery_price") }}</label
            >
            <!-- <label v-if="form_error && !$v.offer.delivery_price.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <v-select-popup
              type="currency"
              :placeholder="$t('message.contracts.delivery_price_currency')"
              v-model="offer.delivery_price_currency"
              :disabled="is_view && is_offer_mine(offer)"
            />

            <!-- <v-select :disabled="is_view && is_offer_mine(offer)" id="delivery_price_currency" :options="currencies" label="display_text" :class="['form-control', typeof offer.delivery_price_currency !== 'undefined' && offer.delivery_price_currency.value!==''?'vs--selected':'']" v-model="offer.delivery_price_currency" :placeholder="$t('message.contracts.delivery_price_currency')" @focus="delivery_currency_focused=true" @blur="delivery_currency_focused=false" @search=fetchCurrencies></v-select> -->
            <!-- <label for="delivery_price_currency" class="form-label-group-label shorter">{{$t('message.contracts.delivery_price_currency')}}</label> -->
          </span>
        </div>
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <!-- <b-form-datepicker :disabled="is_view" :locale="locale" v-model="offer.date_of_load" :placeholder="$t('message.contracts.date_of_load')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
                        <label for="date_of_load" v-if="offer.date_of_load!=''"  class="form-label-group-label shorter topped">{{$t('message.contracts.date_of_load')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="offer.date_of_load = ' '"
              @blur="
                offer.date_of_load == ' '
                  ? (offer.date_of_load = '')
                  : (offer.date_of_load = offer.date_of_load)
              "
              inputClass="form-control"
              :disabled="is_view && is_offer_mine(offer)"
              v-model="offer.date_of_load"
              :placeholder="$t('message.contracts.date_of_load')"
              :inputAttr="{ id: 'date_of_load' }"
            />
            <label
              for="date_of_load"
              class="form-label-group-label shorter"
              :class="
                offer.date_of_load != '' && offer.date_of_load != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.date_of_load") }}</label
            >
          </span>
        </div>
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <!-- <b-form-datepicker :disabled="is_view" :locale="locale" v-model="offer.date_of_delivery" :placeholder="$t('message.contracts.date_of_delivery')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker>
                        <label for="date_of_delivery"   v-if="offer.date_of_delivery!=''"  class="form-label-group-label shorter topped">{{$t('message.contracts.date_of_delivery')}}</label> -->

            <datepicker
              value-type="YYYY-MM-DD"
              format="DD.MM.YYYY"
              @focus="offer.date_of_delivery = ' '"
              @blur="
                offer.date_of_delivery == ' '
                  ? (offer.date_of_delivery = '')
                  : (offer.date_of_delivery = offer.date_of_delivery)
              "
              inputClass="form-control"
              :disabled="is_view && is_offer_mine(offer)"
              v-model="offer.date_of_delivery"
              :placeholder="$t('message.contracts.date_of_delivery')"
              :inputAttr="{ id: 'date_of_delivery' }"
            />
            <label
              for="date_of_delivery"
              class="form-label-group-label shorter"
              :class="
                offer.date_of_delivery != '' && offer.date_of_delivery != null
                  ? 'topped'
                  : ''
              "
              >{{ $t("message.contracts.date_of_delivery") }}</label
            >
          </span>
        </div>
        <div class="col-6">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <input
              :disabled="is_view"
              type="text"
              class="form-control"
              v-model="offer.packaging"
              :placeholder="$t('message.contracts.packaging')"
              autocomplete="off"
              style="cursor: auto"
              id="packaging"
            />
            <label for="packaging" class="form-label-group-label shorter">{{
              $t("message.contracts.packaging")
            }}</label>
          </span>
        </div>
        <div class="col-6">
          <span
            :class="[
              'bmd-form-group mb-2 d-block form-label-group required',
              hazard_class_focused
                ? 'focused'
                : '' /*, $v.offer.hazard_class.$error?'has-danger label-floating':''*/,
            ]"
          >
            <v-select-popup
              :indata="hazard_classes"
              :placeholder="$t('message.contracts.hazard_class')"
              v-model="offer.hazard_class"
              :disabled="is_view"
            />

            <!-- <v-select :disabled="is_view" id="hazard_class" :options="hazard_classes" label="display_text" :class="['form-control', typeof offer.hazard_class !== 'undefined' && offer.hazard_class.value!==''?'vs--selected':'']" v-model="offer.hazard_class" :placeholder="$t('message.contracts.hazard_class')" @focus="hazard_class_focused=true" @blur="hazard_class_focused=false"></v-select> -->
            <!-- <label for="hazard_class" class="form-label-group-label shorter">{{$t('message.contracts.hazard_class')}}</label> -->
            <!-- <label v-if="form_error && !$v.offer.hazard_class.required" class="control-label text-danger d-block">{{$t('message.errors.required')}}</label> -->
          </span>
        </div>
        <div class="col-12">
          <span :class="['bmd-form-group mb-2 d-block form-label-group']">
            <textarea
              :disabled="is_view && is_offer_mine(offer)"
              class="form-control"
              v-model="offer.comments"
              :placeholder="$t('message.contracts.comments')"
              autocomplete="off"
              style="cursor: auto"
              id="comments"
            ></textarea>
            <label for="comments" class="form-label-group-label shorter">{{
              $t("message.contracts.comments")
            }}</label>
          </span>
        </div>
        <div
          class="d-block files-block col-12"
          v-if="!is_view || (is_view && files.length > 0)"
        >
          <h5>{{ $t("message.contracts.attachements") }}</h5>
          <div class="file-o" v-for="(file, index) in files" :key="index">
            <div class="row">
              <div class="col-11">
                <a target="_blank" :href="'/Picture/GetTxtFile/' + file.id"
                  >{{ file.name }} <i class="fas fa-arrow-down"></i
                ></a>
              </div>
              <div class="col-1" v-if="!is_view">
                <button
                  class="btn btn-sm btn-link text-danger"
                  @click="deleteFile(file, index)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <div v-if="!is_view">
            <div v-for="(file, index) in files_att" class="row" :key="index">
              <div class="col-11">
                <input
                  type="file"
                  @change="attachFile($event, index)"
                  class="form-control"
                />
              </div>
              <div class="col-1">
                <button
                  class="btn btn-sm btn-link text-danger"
                  @click="removeFile(index)"
                >
                  &times;
                </button>
              </div>
            </div>
          </div>
          <div v-if="!is_view">
            <button
              class="btn btn-sm btn-outline-success"
              @click="addAttachement"
            >
              {{ $t("message.contracts.add_attachement") }}
            </button>
            <br />
            <small
              ><i>{{
                $t("message.contracts.couriers_attahments_info")
              }}</i></small
            >
          </div>
        </div>
        <div class="col-12 text-right" v-if="!is_view">
          <button class="btn btn-success" @click="submit">
            {{ $t("message.save_and_send") }}
          </button>
        </div>
      </div>
      <!--/row-->
      <div style="margin-left: -24px; margin-right: -24px">
        <div
          class="courier_contract bg-success-light"
          style="padding: 24px"
          v-if="
            (offer.is_accepted && is_owner) ||
            (offer.is_accepted &&
              offer.countragent_2.org_code == current_company.org_code)
          "
        >
          <h4>{{ $t("message.contracts.transport_contract") }}</h4>
          <div class="row">
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.cancel_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.cancel_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="cancel_term"
                />
                <label
                  for="cancel_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.cancel_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.consent_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.consent_term"
                  :placeholder="$t('message.contracts.consent_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="consent_term"
                />
                <label
                  for="consent_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.consent_term") }}</label
                >
              </span>
            </div>

            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.inform_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.inform_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="inform_term"
                />
                <label
                  for="inform_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.inform_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.location_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.location_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="location_term"
                />
                <label
                  for="location_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.location_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.fuel_percent_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.fuel_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="fuel_percent"
                />
                <label
                  for="fuel_percent"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.fuel_percent") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.currency_percent_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.currency_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="currency_percent"
                />
                <label
                  for="currency_percent"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.currency_percent") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.application_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.application_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="application_term"
                />
                <label
                  for="application_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.application_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.customs_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.customs_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customs_term"
                />
                <label
                  for="customs_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.customs_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.delay_abroad_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.delay_abroad_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="delay_abroad_term"
                />
                <label
                  for="delay_abroad_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.delay_abroad_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.delay_home_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.delay_home_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="delay_home_term"
                />
                <label
                  for="delay_home_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.delay_home_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.courier_cis_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.courier_cis_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="courier_cis_delay_amount"
                />
                <label
                  for="courier_cis_delay_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.courier_cis_delay_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.customer_cis_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.customer_cis_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_cis_delay_amount"
                />
                <label
                  for="customer_cis_delay_amount"
                  class="form-label-group-label shorter"
                  >{{
                    $t("message.contracts.customer_cis_delay_amount")
                  }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.courier_eu_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.courier_eu_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="courier_eu_delay_amount"
                />
                <label
                  for="courier_eu_delay_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.courier_eu_delay_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.customer_eu_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.customer_eu_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_eu_delay_amount"
                />
                <label
                  for="customer_eu_delay_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.customer_eu_delay_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="
                  $t('message.contracts.courier_declination_percent_long')
                "
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.courier_declination_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="courier_declination_percent"
                />
                <label
                  for="courier_declination_percent"
                  class="form-label-group-label shorter"
                  >{{
                    $t("message.contracts.courier_declination_percent")
                  }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.penalty_percent_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.penalty_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="penalty_percent"
                />
                <label
                  for="penalty_percent"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.penalty_percent") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.penalty_never_more_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.penalty_never_more"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="penalty_never_more"
                />
                <label
                  for="penalty_never_more"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.penalty_never_more") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="
                  $t('message.contracts.customer_declination_percent_long')
                "
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.customer_declination_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_declination_percent"
                />
                <label
                  for="customer_declination_percent"
                  class="form-label-group-label shorter"
                  >{{
                    $t("message.contracts.customer_declination_percent")
                  }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.act_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.act_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="act_term"
                />
                <label for="act_term" class="form-label-group-label shorter">{{
                  $t("message.contracts.act_term")
                }}</label>
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.repeats_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.repeats_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="repeats_term"
                />
                <label
                  for="repeats_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.repeats_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.force_major_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.force_major_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="force_major_term"
                />
                <label
                  for="force_major_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.force_major_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.claim_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.claim_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="claim_term"
                />
                <label
                  for="claim_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.claim_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.resolve_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.resolve_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="resolve_term"
                />
                <label
                  for="resolve_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.resolve_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.contract_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.contract_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="contract_term"
                />
                <label
                  for="contract_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.contract_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.contract_cancel_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="offer.contract_cancel_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="contract_cancel_term"
                />
                <label
                  for="contract_cancel_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.contract_cancel_term") }}</label
                >
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <pdf
              :document="offer"
              :goods="[]"
              :user_id="0"
              :doc_id="this.contract_id"
              :doc_additional="{}"
              source="transport_contract"
            ></pdf>
            <!-- <button class="btn btn-success" @click="acceptOffer(pre_accept_offer)">{{$t('message.ok')}}</button>
                        <button class="btn btn-danger" @click="unPreAcceptOffer(offer)">{{$t('message.cancel')}}</button> -->
          </div>
        </div>

        <div
          class="courier_contract bg-success-light"
          style="padding: 24px"
          v-if="pre_accept"
        >
          <h4>{{ $t("message.contracts.transport_contract") }}</h4>
          <div class="row">
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.cancel_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.cancel_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="cancel_term"
                />
                <label
                  for="cancel_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.cancel_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.consent_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.consent_term"
                  :placeholder="$t('message.contracts.consent_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="consent_term"
                />
                <label
                  for="consent_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.consent_term") }}</label
                >
              </span>
            </div>

            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.inform_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.inform_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="inform_term"
                />
                <label
                  for="inform_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.inform_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.location_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.location_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="location_term"
                />
                <label
                  for="location_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.location_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.fuel_percent_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.fuel_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="fuel_percent"
                />
                <label
                  for="fuel_percent"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.fuel_percent") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.currency_percent_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.currency_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="currency_percent"
                />
                <label
                  for="currency_percent"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.currency_percent") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.application_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.application_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="application_term"
                />
                <label
                  for="application_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.application_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.customs_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.customs_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customs_term"
                />
                <label
                  for="customs_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.customs_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.delay_abroad_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.delay_abroad_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="delay_abroad_term"
                />
                <label
                  for="delay_abroad_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.delay_abroad_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.delay_home_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.delay_home_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="delay_home_term"
                />
                <label
                  for="delay_home_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.delay_home_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.courier_cis_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.courier_cis_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="courier_cis_delay_amount"
                />
                <label
                  for="courier_cis_delay_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.courier_cis_delay_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.customer_cis_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.customer_cis_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_cis_delay_amount"
                />
                <label
                  for="customer_cis_delay_amount"
                  class="form-label-group-label shorter"
                  >{{
                    $t("message.contracts.customer_cis_delay_amount")
                  }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.courier_eu_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.courier_eu_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="courier_eu_delay_amount"
                />
                <label
                  for="courier_eu_delay_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.courier_eu_delay_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.customer_eu_delay_amount_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.customer_eu_delay_amount"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_eu_delay_amount"
                />
                <label
                  for="customer_eu_delay_amount"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.customer_eu_delay_amount") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="
                  $t('message.contracts.courier_declination_percent_long')
                "
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.courier_declination_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="courier_declination_percent"
                />
                <label
                  for="courier_declination_percent"
                  class="form-label-group-label shorter"
                  >{{
                    $t("message.contracts.courier_declination_percent")
                  }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.penalty_percent_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.penalty_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="penalty_percent"
                />
                <label
                  for="penalty_percent"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.penalty_percent") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.penalty_never_more_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.penalty_never_more"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="penalty_never_more"
                />
                <label
                  for="penalty_never_more"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.penalty_never_more") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="
                  $t('message.contracts.customer_declination_percent_long')
                "
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.customer_declination_percent"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_declination_percent"
                />
                <label
                  for="customer_declination_percent"
                  class="form-label-group-label shorter"
                  >{{
                    $t("message.contracts.customer_declination_percent")
                  }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.act_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.act_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="act_term"
                />
                <label for="act_term" class="form-label-group-label shorter">{{
                  $t("message.contracts.act_term")
                }}</label>
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.repeats_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.repeats_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="repeats_term"
                />
                <label
                  for="repeats_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.repeats_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.force_major_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.force_major_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="force_major_term"
                />
                <label
                  for="force_major_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.force_major_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.claim_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.claim_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="claim_term"
                />
                <label
                  for="claim_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.claim_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.resolve_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.resolve_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="resolve_term"
                />
                <label
                  for="resolve_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.resolve_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.contract_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.contract_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="contract_term"
                />
                <label
                  for="contract_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.contract_term") }}</label
                >
              </span>
            </div>
            <div class="col-md-6">
              <span
                :class="['bmd-form-group mb-2 d-block form-label-group']"
                :title="$t('message.contracts.contract_cancel_term_long')"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="pre_accept_offer_fields.contract_cancel_term"
                  :placeholder="$t('message.contracts.cancel_term')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="contract_cancel_term"
                />
                <label
                  for="contract_cancel_term"
                  class="form-label-group-label shorter"
                  >{{ $t("message.contracts.contract_cancel_term") }}</label
                >
              </span>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <button
              class="btn btn-sm btn-success"
              @click="acceptOffer(pre_accept_offer)"
            >
              {{ $t("message.ok") }}
            </button>
            <button
              class="btn btn-sm btn-danger"
              @click="unPreAcceptOffer(offer)"
            >
              {{ $t("message.cancel") }}
            </button>
          </div>
        </div>

        <div class="col-12" v-if="is_offer_mine(offer)">
          <h5>{{ $t("message.contracts.couriers") }}</h5>
          <b-table :items="couriers" :fields="couriers_fields">
            <template #cell(invite)="data">
              <label
                ><input
                  type="checkbox"
                  :disabled="is_view"
                  v-model="offer.invites"
                  :value="data.item.org_code"
                />
                {{ $t("message.contracts.invite") }}</label
              >
            </template>
          </b-table>
        </div>

        <div
          class="col-12 d-flex justify-content-between"
          v-if="
            i_can_accept_or_decline && offer.is_accepted !== true && !pre_accept
          "
        >
          <button class="btn btn-sm btn-success" @click="preAcceptOffer(offer)">
            {{ $t("message.contracts.offer_accept") }}
          </button>
          <button class="btn btn-sm btn-danger" @click="declineOffer(offer)">
            {{ $t("message.contracts.offer_decline") }}
          </button>
        </div>
        <div v-if="offer.is_accepted && !checkSigned(offer) && is_selected">
          <button
            class="btn btn-sm btn-success float-left"
            @click="submit_and_sign_dialog()"
          >
            {{ $t("message.contracts.submit_and_sign_button") }}
          </button>
        </div>
      </div>
    </b-modal>
    <b-modal
      id="modal-select-ecp-type"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-sm btn-outline-success btn-round"
          @click="submit_and_sign()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-sm btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-sm btn-success btn-round"
          :class="['btn btn-success btn-round', loading_sign ? 'pl-5' : '']"
          :disabled="sign_with_code_code.length == 0"
          @click="sign_with_code_phase2()"
        >
          <div class="loading my-1 loading-button" v-if="loading_sign"></div>
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-sm btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
// import { required } from 'vuelidate/lib/validators'
export default {
  data() {
    return {
      loading_sign: false,
      sign_with_code_code: "",
      show_code_sign_type: false,
      can_request: false,
      pre_accept: false,
      pre_accept_offer: {},
      pre_accept_offer_fields: {
        cancel_term: "",
        consent_term: "",
        inform_term: "",
        location_term: "",
        fuel_percent: "",
        currency_percent: "",
        application_term: "",
        customs_term: "",
        delay_abroad_term: "",
        delay_home_term: "",
        courier_cis_delay_amount: "",
        customer_cis_delay_amount: "",
        courier_eu_delay_amount: "",
        customer_eu_delay_amount: "",
        courier_declination_percent: "",
        penalty_percent: "",
        penalty_never_more: "",
        customer_declination_percent: "",
        act_term: "",
        repeats_term: "",
        force_major_term: "",
        claim_term: "",
        resolve_term: "",
        contract_term: "",
        contract_cancel_term: "",
      },
      is_selected: false,
      current_company: {
        org_code: "",
        org_name: "",
      },
      selected_bin: "",
      form_error: false,
      // can_add: true,
      current_courier_offer_id: "",
      courier_offers: [],
      delivery_type_focused: false,
      delivery_currency_focused: false,
      hazard_class_focused: false,
      currencies: [],
      files_att: [],
      files: [],
      is_view: false,
      offer: {
        countragent_1: { org_name: "", org_code: "" },
        countragent_2: { org_name: "", org_code: "" },
        type_of_movement: { value: "", display_text: "" },
        from_address: "",
        to_address: "",
        weight: "",
        volume: "",
        delivery_price_currency: { value: "" },
        date_of_load: "",
        date_of_delivery: "",
        hazard_class: { value: "" },
        comments: "",
        invites: [],
      },
      hazard_classes: [
        {
          value: "class1",
          display_text: this.$t("message.contracts.hazard_class1"),
        },
        {
          value: "class2",
          display_text: this.$t("message.contracts.hazard_class2"),
        },
        {
          value: "class3",
          display_text: this.$t("message.contracts.hazard_class3"),
        },
        {
          value: "class4",
          display_text: this.$t("message.contracts.hazard_class4"),
        },
        {
          value: "class5",
          display_text: this.$t("message.contracts.hazard_class5"),
        },
        {
          value: "class6",
          display_text: this.$t("message.contracts.hazard_class6"),
        },
        {
          value: "class7",
          display_text: this.$t("message.contracts.hazard_class7"),
        },
        {
          value: "class8",
          display_text: this.$t("message.contracts.hazard_class8"),
        },
        {
          value: "class9",
          display_text: this.$t("message.contracts.hazard_class9"),
        },
        {
          value: "class0",
          display_text: this.$t("message.contracts.hazard_class0"),
        },
      ],
      delivery_types: [
        {
          value: "auto",
          display_text: this.$t("message.contracts.delivery_type_auto"),
        },
        {
          value: "railway",
          display_text: this.$t("message.contracts.delivery_type_railway"),
        },
        {
          value: "avia",
          display_text: this.$t("message.contracts.delivery_type_avia"),
        },
        {
          value: "sea",
          display_text: this.$t("message.contracts.delivery_type_sea"),
        },
        {
          value: "post",
          display_text: this.$t("message.contracts.delivery_type_post"),
        },
      ],
      courier_offers_fields: () => {
        if (this.is_owner && !this.is_selected) {
          return [
            {
              key: "view",
              label: this.$t("message.contracts.view"),
            },
            {
              key: "countragent_2.org_name",
              label: this.$t("message.contracts.courier"),
            },
            {
              key: "delievery_price",
              label: this.$t("message.contracts.delivery_price"),
            },
            {
              key: "date_of_delivery",
              label: this.$t("message.contracts.delivery_date"),
            },
            {
              key: "offer_date",
              label: this.$t("message.contracts.offer_date"),
            },
            {
              key: "choose",
              label: this.$t("message.contracts.choose_courier"),
              class: "text-right",
            },
          ];
        } else {
          return [
            {
              key: "view",
              label: this.$t("message.contracts.view"),
            },
            {
              key: "countragent_2.org_name",
              label: this.$t("message.contracts.courier"),
            },
            {
              key: "delievery_price",
              label: this.$t("message.contracts.delivery_price"),
            },
            {
              key: "date_of_delivery",
              label: this.$t("message.contracts.delivery_date"),
            },
            {
              key: "offer_date",
              label: this.$t("message.contracts.offer_date"),
            },
          ];
        }
      },
      couriers: [],
      couriers_fields: [
        {
          key: "org_name",
          label: this.$t("message.contracts.courier_name"),
        },
        {
          key: "org_code",
          label: this.$t("message.contracts.courier_code"),
        },
        {
          key: "invite",
          label: this.$t("message.contracts.invite"),
        },
      ],
    };
  },
  mounted() {
    this.load();
    this.fetchCurrencies("");
    this.loadCouriers();
    this.loadCompanyName();
    this.$root.$on("show-courier-offer", () => {
      console.log($this.$route.params.id);
    });
  },
  props: {
    contract_id: [String, Number],
    can_add: Boolean,
    is_owner: Boolean,
    is_deal: Boolean,
    roles: Array,
    is_full: Boolean,
  },
  computed: {
    i_can_accept_or_decline() {
      // return true
      if (!this.is_courier) return false;
      if (
        typeof this.offer.countragent_2 != "undefined" &&
        typeof this.offer.countragent_2.org_code != "undefined" &&
        typeof this.current_company != "undefined" &&
        typeof this.current_company.org_code != "undefined"
      ) {
        if (
          this.offer.countragent_2.org_code.trim() ==
          this.current_company.org_code.trim()
        )
          return true;
      }
      return false;
    },
    is_courier() {
      var result = true;
      if (typeof this.roles !== "undefined") {
        this.roles.forEach((role) => {
          if (role.toLowerCase() == "courier") result = true;
        });
      }
      return result;
    },
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  methods: {
    /**
     * Hides the form to input all details of the transport contract
     */
    unPreAcceptOffer() {
      this.pre_accept = false;
    },
    /**
     * Displays the form to input all details of the transport contract
     */
    preAcceptOffer(offer) {
      this.pre_accept = true;
      this.pre_accept_offer = offer;
    },
    checkSigned(offer) {
      if (this.is_owner && offer.is_signed_by_owner) return true;
      if (this.is_courier && offer.is_signed_by_courier) return true;

      return false;
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type");
    },
    recalculate_selected() {
      if (this.selected_bin !== "") {
        if (this.courier_offers.length > 0) {
          this.courier_offers.forEach((i) => {
            if (i.countragent_2.org_code == this.selected_bin)
              i.is_selected = true;
          });
        }
        console.log("recalculate");
        console.log(this.selected_bin + " " + this.is_selected);
      }
    },
    rowClass(item) {
      if (this.is_selected) {
        if (item.is_selected) return "";
        else {
          return "text-line-through";
        }
      }
      return "";
    },
    showCurrency(currency) {
      if (typeof currency === "object") {
        if (typeof currency.display_text !== "undefined")
          return currency.display_text;
        else return "";
      } else {
        // return ''
        // console.log(this.currencies)
        var index = this.currencies.findIndex((i) => i.value == currency);
        if (index > -1) return this.currencies[index].display_text;
        return "";
      }
    },
    submit_and_sign() {
      this.loading = true;
      axios
        .get(
          window.base +
            "/Contract/getCourierOfferXml?contract_id=" +
            this.contract_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            // window.getKeyInfo('PKCS12', "getKeyInfoBack");
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            // console.log(result)
            // window.signXml("PKCS12", "SIGNATURE", this.xml, ()=>{
            // });
            // return true;
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                console.log(result);
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      fd.append("contract_id", this.contract_id);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/contract/AddCourierContractSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.contract_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type");
                          this.$bvModal.hide("modal-offer");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.contract_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.contract_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                window.webSocket.removeEventListener("message", {});
                window.webSocket.close();
              }
            }
          };
        });
    },
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        this.loading_sign = true;
        axios
          .get(
            window.base +
              "/document/getCourierOfferXml?contract_id=" +
              this.contract_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.contract_id);
                fd.append("signature", response.data);
                fd.append("type", "code");
                axios
                  .post(
                    window.base + "/document/AddCourierContractSignature",
                    fd,
                  )
                  .then(() => {
                    this.loading_sign = false;
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.load();
                    this.$bvModal.hide("modal-select-ecp-type");
                    this.$bvModal.hide("modal-offer");
                  })
                  .catch((e) => {
                    this.loading_sign = false;
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type");
                  });
              });
          });
      }
    },
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    acceptOffer(offer) {
      var fd = new FormData();
      fd.append("courier_offer_id", offer.ID);
      fd.append("org_id", this.current_company.org_code);
      fd.append("comment", offer.comments);
      fd.append("loading_date", offer.date_of_load);
      fd.append("delivery_date", offer.date_of_delivery);
      fd.append("price", offer.delivery_price);
      fd.append("price_currency", offer.delivery_price_currency.value);
      //adding details of the contract
      for (var i in this.pre_accept_offer_fields) {
        fd.append(i, this.pre_accept_offer_fields[i]);
      }

      axios
        .post(window.base + "/contract/acceptCourierOffer", fd)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.success"),
              timeout: 5000,
            }).show();
            offer.is_accepted = true;
            this.load();
            this.$bvModal.hide("modal-offer");
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
          }
        });
    },
    declineOffer(offer) {
      var fd = new FormData();
      fd.append("courier_offer_id", offer.ID);
      fd.append("comment", offer.comments);
      fd.append("org_id", this.current_company.org_code);
      axios
        .post(window.base + "/contract/declineCourierOffer", fd)
        .then((response) => {
          if (response.data.status == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.decline-delivery_offer-ok"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-offer");
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.decline-delivery_offer-nok"),
              timeout: 5000,
            }).show();
          }
        });
    },
    is_offer_mine(offer) {
      return offer.countragent_1.org_code == this.current_company.org_code;
    },
    can_request_for_transport() {
      axios
        .get(
          window.base +
            "/contract/CanRequestForTransport?contract_id=" +
            this.contract_id,
        )
        .then((response) => {
          var tmp = false;
          if (response.data.result == "True") {
            tmp = true;
          }
          this.can_request = tmp && this.is_owner;
        });
    },
    loadCompanyName() {
      if (this.$store.state.firmfull == false) {
        axios.get(window.base + "/document/getfirmfull").then((response) => {
          this.$store.commit("load_firm", response.data);
          this.current_company = response.data.organizations;
        });
      } else {
        this.current_company = this.$store.state.firmfull.organizations;
      }
    },
    submit() {
      // this.$v.$touch()
      // if(this.$v.offer.$invalid) {
      // this.form_error = true
      // setTimeout(()=>{
      // $('html,body').animate({scrollTop: $('.has-danger').eq(0).offset().top-50}, 1000)
      // }, 100)
      /*}else*/ {
        this.form_error = false;
        var fd = new FormData();
        for (var i in this.offer) {
          if (typeof this.offer[i] == "object")
            if (i == "invites") fd.append(i, this.offer[i]);
            else if (i == "countragent_1") fd.append(i, this.offer[i].org_code);
            else fd.append(i, this.offer[i].value);
          else fd.append(i, this.offer[i]);
        }
        for (var i in this.files_att) {
          fd.append("file[" + i + "]", this.files_att[i]);
        }
        fd.append("contract_id", this.contract_id);
        axios
          .post(window.base + "/contract/createCourierRequest", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.create-delivery_offer-ok"),
                timeout: 5000,
              }).show();
              this.$bvModal.hide("modal-offer");
              this.load();
            } else {
              new Noty({
                theme: "light",
                type: "error",
                text: this.$root.$t(
                  "message.message.create-delivery_offer-nok",
                ),
                timeout: 5000,
              }).show();
            }
          });
      }
    },
    loadCouriers() {
      axios.get(window.base + "/contract/getcouriers").then((response) => {
        this.couriers = response.data;
      });
    },
    attachFile(event, index) {
      if (typeof event.target.files[0] !== "undefined")
        this.files_att[index] = event.target.files[0];
    },
    removeFile(index) {
      this.files_att.splice(index, 1);
    },
    addAttachement() {
      this.files_att.push("");
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
          // this.$data[var_name] = response.data
        });
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 100);
    },
    selectCourier(current_courier_offer_id) {
      var fd = new FormData();
      var offer =
        this.courier_offers[
          this.courier_offers.findIndex(
            (offer) => offer.ID == current_courier_offer_id,
          )
        ];
      fd.append("courier_offer_id", current_courier_offer_id);
      fd.append("contract_id", this.contract_id);
      fd.append("courier_id", offer.countragent_2.org_code);
      axios
        .post(window.base + "/contract/selectCourierOffer", fd)
        .then((response) => {
          if (response.data.status == 200) {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.select-delivery_offer-ok"),
              timeout: 5000,
            }).show();
            this.is_selected = true;
            offer.is_selected = true;
            axios
              .get(
                window.base +
                  "/contract/selectedCourierOffer?contract_id=" +
                  this.contract_id,
              )
              .then((response) => {
                if (typeof response.data.org_name !== "undefined") {
                  if (!response.data.org_name) this.is_selected = false;
                  else {
                    this.is_selected = true;
                    this.selected_bin = response.data.org_code;
                    this.recalculate_selected();
                  }
                } else {
                  this.is_selected = false;
                }
              });
            this.$bvModal.hide("modal-offer");
          } else {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t("message.message.select-delivery_offer-nok"),
              timeout: 5000,
            }).show();
          }
        });
    },
    createRequest() {
      this.is_view = false;
      // this.offer = {
      //     countragent_1: {...this.current_company},
      //     type_of_movement: {value: '', display_text: '',},
      //     from_address: '',
      //     to_address: '',
      //     weight: '',
      //     volume: '',
      //     delivery_price_currency: {value: ''},
      //     date_of_load: '',
      //     date_of_delivery: '',
      //     hazard_class: {value: '',},
      //     comments: '',
      //     invites: []
      // }
      axios
        .get(
          window.base +
            "/Contract/GetContract?attis_contract_id=" +
            this.contract_id,
        )
        .then((response) => {
          this.is_view = false;
          this.$set(this, "offer", {
            countragent_1: { ...this.current_company },
            type_of_movement: { value: "", display_text: "" },
            from_address: response.data.point_of_departure,
            to_address: response.data.destination_point,
            weight: "",
            volume: "",
            delivery_price_currency: { value: "" },
            date_of_load: "",
            date_of_delivery: response.data.attis_contract_date,
            hazard_class: { value: "" },
            comments: "",
            invites: [],
          });
          setTimeout(() => {
            var el = this;
            $("#from_address").click(function () {
              el.cus_adr = new ymaps.SuggestView("from_address");
              el.cus_adr.events.add(["select"], (event) => {
                el.offer.from_address = event.get("item").value;
              });
            });
            $("#to_address").click(function () {
              el.cus_adr = new ymaps.SuggestView("to_address");
              el.cus_adr.events.add(["select"], (event) => {
                el.offer.to_address = event.get("item").value;
              });
            });
          }, 1000);
        });
    },
    openOffer(offer) {
      // this.offer = {...offer}
      this.$set(this, "offer", offer);
      if (typeof this.offer.type_of_movement !== "object")
        this.offer.type_of_movement =
          this.delivery_types[
            this.delivery_types.findIndex(
              (i) => i.value == offer.type_of_movement,
            )
          ];
      if (typeof this.offer.hazard_class !== "object")
        this.offer.hazard_class =
          this.hazard_classes[
            this.hazard_classes.findIndex((i) => i.value == offer.hazard_class)
          ];
      if (typeof this.offer.delivery_price_currency !== "object")
        this.offer.delivery_price_currency =
          this.currencies[
            this.currencies.findIndex(
              (i) => i.value == offer.delivery_price_currency,
            )
          ];
      this.is_view = true;
      this.$set(this, "files", offer.files);
      this.offer.invites = offer.invites;
      if (typeof offer != "object") this.offer.invites = [];

      this.offer.cancel_term = offer.cancel_term;
      this.offer.consent_term = offer.consent_term;
      this.offer.inform_term = offer.inform_term;
      this.offer.location_term = offer.location_term;
      this.offer.fuel_percent = offer.fuel_percent;
      this.offer.currency_percent = offer.currency_percent;
      this.offer.application_term = offer.application_term;
      this.offer.customs_term = offer.customs_term;
      this.offer.delay_abroad_term = offer.delay_abroad_term;
      this.offer.delay_home_term = offer.delay_home_term;
      this.offer.courier_cis_delay_amount = offer.courier_cis_delay_amount;
      this.offer.customer_cis_delay_amount = offer.customer_cis_delay_amount;
      this.offer.courier_eu_delay_amount = offer.courier_eu_delay_amount;
      this.offer.customer_eu_delay_amount = offer.customer_eu_delay_amount;
      this.offer.courier_declination_percent =
        offer.courier_declination_percent;
      this.offer.penalty_percent = offer.penalty_percent;
      this.offer.penalty_never_more = offer.penalty_never_more;
      this.offer.customer_declination_percent =
        offer.customer_declination_percent;
      this.offer.act_term = offer.act_term;
      this.offer.repeats_term = offer.repeats_term;
      this.offer.force_major_term = offer.force_major_term;
      this.offer.claim_term = offer.claim_term;
      this.offer.resolve_term = offer.resolve_term;
      this.offer.contract_term = offer.contract_term;
      this.offer.contract_cancel_term = offer.contract_cancel_term;

      // axios.get(window.base + '/document/getFirmbyBin?bin='+offer.countragent_1.org_code).then(response=>{
      //         this.offer.org1 = response.data
      //         axios.get(window.base + '/document/getFirmbyBin?bin='+offer.countragent_2.org_code).then(res=>{
      //             this.offer.org2 = res.data
      //         })

      // })
      axios
        .get(
          window.base +
            "/library?type=org_type&qty=" +
            100000 +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var org_types = response.data;
          axios
            .get(
              window.base +
                "/document/getFirmbyBin?bin=" +
                offer.countragent_1.org_code,
            )
            .then((res1) => {
              this.offer.org1 = res1.data;
              var tmp1 = org_types.filter((obj) => {
                return obj.value == this.offer.org1.organizations.org_type;
              });
              if (typeof tmp1[0] !== "undefined")
                this.offer.org1.organizations.org_type = tmp1[0].display_text;
              axios
                .get(
                  window.base +
                    "/document/getFirmbyBin?bin=" +
                    offer.countragent_2.org_code,
                )
                .then((res) => {
                  this.offer.org2 = res.data;
                  var tmp2 = org_types.filter((obj) => {
                    return obj.value == this.offer.org2.organizations.org_type;
                  });
                  if (typeof tmp2[0] !== "undefined")
                    this.offer.org2.organizations.org_type =
                      tmp2[0].display_text;
                });
            });
        });

      this.$bvModal.show("modal-offer");
      // console.log(this.offer, this.is_view)
      // console.log(this.offer.countragent_1.org_code, this.current_company.org_code, this.offer.countragent_1.org_code == this.current_company.org_code)
    },
    momentum(date) {
      return moment(date).format("DD.MM.Y");
    },
    load() {
      this.pre_accept = false;
      var httpString = "";
      this.can_request_for_transport();
      console.log("is_full");
      console.log(this.is_full);
      if (this.is_full) {
        console.log("courier offer full");
        httpString = window.base + "/contract/getAllCourierOffers";
      } else {
        console.log("courier offer by contract");
        httpString =
          window.base +
          "/contract/getCourierOffers?contract_id=" +
          this.contract_id;
      }
      axios.get(httpString).then((response) => {
        this.courier_offers = response.data;
        this.recalculate_selected();
        if (this.$route.name == "courier-single") {
          let offer =
            this.courier_offers[
              this.courier_offers.findIndex(
                (i) => i.ID == this.$route.params.oid,
              )
            ];
          this.openOffer(offer);
        }
      });
      if (!this.is_full) {
        axios
          .get(
            window.base +
              "/contract/selectedCourierOffer?contract_id=" +
              this.contract_id,
          )
          .then((response) => {
            if (typeof response.data.org_name !== "undefined") {
              if (!response.data.org_name) this.is_selected = false;
              else {
                console.log("atejo i else");
                this.is_selected = true;
                this.selected_bin = response.data.org_code;
                this.recalculate_selected();
              }
            } else {
              this.is_selected = false;
            }
          });
      }
    },
  },
  /*validations:{
        offer: {
            type_of_movement:{
                required
            },	
            from_address: {
                required
            },
            to_address: {
                required
            },
            weight: {
                require
            },
            volume: {
                require
            },
            delivery_price: {
                require
            },
            hazard_class: {
                require
            }
        },
    }*/
};
</script>
<style>
.text-line-through td {
  text-decoration: line-through;
}
</style>

<style scoped>
@media (max-width: 768px) {
  .table-responsive {
		width: 100%;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		min-width: 600px;
  }
  .table-wrapper {
	  overflow-x: auto;
  }
}
</style>
